import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../common/html/checkbox'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import {
  changeCheckedProfileIds,
  selectCheckedProfileIds,
  selectCustomProfileIds,
} from '../store/slice'

export const CheckboxAll = () => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const customProfileIds = useSelector(selectCustomProfileIds)
  const checkedProfileIds = useSelector(selectCheckedProfileIds())
  const listChecked = customProfileIds.filter((id) => checkedProfileIds[id])

  const isStandardUser = userType?.userTypeId === USER_TYPE.STANDARD

  const getChecked = () => {
    const listCheckedLength = listChecked.length
    return listCheckedLength === 0
      ? false
      : listCheckedLength === customProfileIds.length
      ? true
      : -1
  }

  const onChange = (isCheck) => {
    const payload = customProfileIds.reduce(
      (prev, curr) => ({ ...prev, [curr]: isCheck }),
      {},
    )
    dispatch(changeCheckedProfileIds(payload))
  }

  return isStandardUser || !customProfileIds.length ? null : (
    <Checkbox checked={getChecked()} onChange={onChange} />
  )
}
